/* The questions card: board O's layout (the foot with its hint over a hairline), board M's width. */

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-18px);
}

.question {
  display: flex;
  flex-direction: column;
  gap: var(--space-10px);
  min-width: 0;
  margin: var(--space-0);
  padding: var(--space-0);
  border: 0;
}

.title {
  padding: var(--space-0);
  margin-bottom: var(--space-10px);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-heading);
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.foot {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding-top: var(--space-3);
  border-top: var(--border-hairline) solid var(--border);
}

.hint {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-label);
  font-weight: var(--fw-regular);
  color: var(--text-2);
}
